// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

/**
 * Display names for AEM's raw `equipment_type` (a free string in the contract,
 * no enum), keyed lower-case. The one mapping the Home equipment filter chips
 * read; extend it here when AEM starts sending a new type.
 */
export const EQUIPMENT_TYPE_LABELS: Record<string, string> = {
  power: 'Power',
  cooling: 'Cooling',
  it: 'IT',
  ups: 'UPS',
  pdu: 'PDU',
  rpp: 'RPP',
  ats: 'ATS',
  generator: 'Generator',
  chiller: 'Chiller',
  crah: 'CRAH',
  crac: 'CRAC',
  battery: 'Battery',
  switchgear: 'Switchgear',
  transformer: 'Transformer',
};

const warned = new Set<string>();

/**
 * Mapped display name, or the raw value unchanged (warned once per value).
 * AEM also sends the type with a `Type` suffix (`PDUType`, `UPSType`); the
 * suffix is dropped before the lookup so both spellings map to one label.
 */
export function equipmentTypeDisplayName(raw: string): string {
  const key = raw.trim().toLowerCase().replace(/type$/, '');
  const label = EQUIPMENT_TYPE_LABELS[key];
  if (label) return label;
  if (!warned.has(raw)) {
    warned.add(raw);
    console.warn(`Unmapped AEM equipment_type "${raw}"; showing it as-is`);
  }
  return raw;
}

/** Test seam: forget which unknown values were already logged. */
export function resetEquipmentTypeWarnings(): void {
  warned.clear();
}
